export namespace Enums {

    export enum ServiceProviderType { MSP = 1, Enterprise = 2 }
    export enum NoOfTechnicians { JustMe = 1, TwotoFour = 2, FivetoNine = 3, tentoNineteen = 4, tweentyPlus = 5 }

    export enum OTPChannel
    {
        sms = 1,
        email = 2
    }
}
